export function calculateStats(
  faseAtiva: any,
  client_product: any,
  phaseForms: any,
  product: any
) {
  let completed = 0;
  let pending = 0;
  let overdue = 0;
  let notStarted = 0;

  let completed_phase = 0;
  let pending_phase = 0;
  let overdue_phase = 0;
  let notStarted_phase = 0;
  console.log('fase ativa123', faseAtiva)

  if (faseAtiva?.activities) {
    faseAtiva.activities.forEach((activity: any) => {
      // if (activity.type === "form") {
      //   const form = phaseForms[activity.typeRefId];
      //   if (form?.status === "completed") {
      //     completed++;
      //   } else if (form?.status === "pending") {
      //     pending++;
      //   } else {
      //     notStarted++;
      //   }
      // } else {
      let enter = false;
      let isChecked = false;
      Object.keys(client_product?.phases_init ?? {}).map((item) => {
        console.log(item, activity, client_product?.phases_init[item])
        if (item == activity._id) {
          enter = true;
          if (client_product?.phases_init[item].finished == false) {
            pending++;
          }
          else if (client_product?.phases_init[item].finished == true) {
            completed++;
            isChecked = true;
          }
        }
      })
      if (enter == false) {
        notStarted++;
      }
      // const isChecked = client_product?.phases_init?.includes(activity._id);
      // if (isChecked) completed++;
      // else notStarted++;
      // }
    });
  }
  if (product) {
    let phases_check:any={};
    product.phases?.map((item: any) => {
      phases_check[item._id]={};
        console.log(item)

      item?.activities?.map((item2: any) => {
        console.log(item2)
        if(client_product?.phases_init?.[item2._id]){
          phases_check[item._id][item2._id]=client_product?.phases_init?.[item2._id]?.finished
        }
      })
      if(item.activities.length>0){

        if(Object.keys(phases_check[item._id]).length==item.activities.length){
          if(Object.values(phases_check[item._id]).includes(false)){
            pending_phase++;
          }
          else{
            completed_phase++;
          }
        }
        else if(Object.keys(phases_check[item._id]).length==0){
          notStarted_phase++;
        }
        else{
          pending_phase++;
        }
      }

    })
  }
  console.log({ completed, pending, overdue, notStarted })
  return { completed, pending, overdue, notStarted, completed_phase, pending_phase, overdue_phase, notStarted_phase };
}

export function mapActivityData(
  forms: any[],
  proccessData: any[],
  productPhases: any[],
  documents: any[]
) {
  let docsFilledMap: any = {};
  let phaseFormsIdFilled: any = {};
  let filled_forms: any = [];
  console.log('processdata',proccessData)

  const getFormStatus = (formDef: any, filledData: any[]) => {
    if (!filledData || filledData.length === 0) return "notStarted";

    const relevantFields =
      formDef.formFields?.filter(
        (f: any) =>
          f.type !== "PAGE" &&
          f.type !== "TITLE" &&
          f.type !== "SUBTITLE" &&
          f.type !== "PARAGRAPH"
      ) || [];

    if (relevantFields.length === 0) return "completed";
    if (filledData.length >= relevantFields.length) return "completed";
    return "pending";
  };

  productPhases.forEach((item: any) => {
    item.activities.forEach((item2: any) => {
      // if (item2.type == "form") {
        let form = forms.find((f: any) => f._id == item2.typeRefId);
        if (form) {
          form = { ...form };
          form.filled = "not";
          form.status = "notStarted";
          form.phase = item;
          form.activity = item2;
          phaseFormsIdFilled[item2.typeRefId] = form;
        }
      // }
    });
  });

  proccessData.forEach((item3: any) => {
    filled_forms.push(...item3.filledForms);
    item3.filledForms.forEach((item4: any) => {
      if (phaseFormsIdFilled[item4.phaseFormId] != undefined) {
        const formDef = phaseFormsIdFilled[item4.phaseFormId];
        const status = getFormStatus(formDef, item4.data);

        phaseFormsIdFilled[item4.phaseFormId] = {
          ...item4,
          phase: formDef.phase,
          activity: formDef.activity,
          status: status,
        };
      }
      item4?.docs?.forEach((item5: any) => {
        docsFilledMap[item5.formFieldId] = { ...item5 };
        docsFilledMap[item5.formFieldId].name = documents.find(
          (item10: any) => item5.formFieldId == item10._id
        )?.name;

        docsFilledMap[item5.formFieldId.replace('docs_','')] = { ...item5 };
        docsFilledMap[item5.formFieldId.replace('docs_','')].name = documents.find(
          (item10: any) => item5.formFieldId == item10._id
        )?.name;

        const formDef =
          phaseFormsIdFilled[item4.phaseFormId] ||
          forms.find((f: any) => f._id == item4.phaseFormId);

        if (formDef) {
          const field = formDef.formFields?.find(
            (f: any) => f._id == item5.formFieldId
          );
          if (field?.tag) {
            docsFilledMap[field.tag] = docsFilledMap[item5.formFieldId];
          }
          if (
            formDef.activity?.documents?.length === 1 &&
            !docsFilledMap[formDef.activity.documents[0]]
          ) {
            const docId = formDef.activity.documents[0];
            docsFilledMap[docId] = docsFilledMap[item5.formFieldId];
          }
        }
      });
    });
  });

  return { docsFilledMap, phaseFormsIdFilled, filled_forms };
}
